import React from 'react';
const spaces = ['Lengua', 'Ciencias Sociales', 'Ciencias Naturales', 'Tutorías', 'Orientación', 'Proyectos interdisciplinarios', 'Espacios institucionales'];
export function VersatilitySection() {
  return;
}